// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__339Qt","header":"ClearentDisclaimer_header__czNCY","inner":"ClearentDisclaimer_inner__3XJJQ"};